// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"357": "0542da7ac697f95b","757": "77c5a81c80945984",}[chunkId] + ".js"
}